import ExternalTransfersPage from "components/pages/ExternalTransfersPage"

/**
 * @function CaptureExternalTransfers
 * @param { VOID } - No arguments are passed.
 * @returns {React.Component}
 * @description Capture "002_ExternalTransfers" for MABI23, group "External Transfers".
 * @example
 *  <CaptureExternalTransfers />
 */
export default function CaptureExternalTransfers(props) {
    return <ExternalTransfersPage />;
}